var React = require('react');

function ScheduleArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.1 0l-1.3 1.7 4.9 4.2H0v2.2h18.7l-4.9 4.2 1.3 1.7L23 7z"}));
}

ScheduleArrowIcon.defaultProps = {"viewBox":"0 0 23 14"};

module.exports = ScheduleArrowIcon;

ScheduleArrowIcon.default = ScheduleArrowIcon;
